<template>
  <div>
    <Head title="Create Accessory Group" />
    
    <h1 class="text-3xl font-bold mb-8">Create New Accessory Group</h1>

    <div class="max-w-3xl bg-white shadow overflow-hidden sm:rounded-md">
      <form @submit.prevent="store">
        <div class="px-4 py-5 bg-gray-50 sm:px-6">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            Group Information
          </h3>
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            Create a new group to organize accessories (e.g., T1400, T1460, T2000).
          </p>
        </div>
        
        <div class="px-4 py-5 sm:p-6">
          <div class="grid grid-cols-6 gap-6">
            <div class="col-span-6 sm:col-span-3">
              <text-input
                v-model="form.name"
                :error="form.errors.name"
                class="pb-8 pr-6 w-full"
                label="Group Name *"
                placeholder="e.g., T1400, T1460, T2000"
              />
            </div>

            <div class="col-span-6 sm:col-span-3">
              <label class="form-label">System</label>
              <select v-model="form.system_id" class="form-select mt-1 w-full">
                <option :value="null">All Systems</option>
                <option v-for="system in systems" :key="system.id" :value="system.id">
                  {{ system.name }}
                </option>
              </select>
              <div v-if="form.errors.system_id" class="form-error">{{ form.errors.system_id }}</div>
            </div>

            <div class="col-span-6">
              <text-input
                v-model="form.description"
                :error="form.errors.description"
                class="pb-8 pr-6 w-full"
                label="Description"
                placeholder="Optional description for this group"
              />
            </div>

            <div class="col-span-6">
              <div class="flex items-center">
                <checkbox-input
                  v-model="form.is_active"
                  :error="form.errors.is_active"
                />
                <label class="ml-2 text-sm text-gray-900">Active</label>
              </div>
            </div>
          </div>
        </div>

        <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
          <div class="flex items-center justify-between">
            <Link class="btn-gray" href="/accessory-groups">Cancel</Link>
            <loading-button 
              :loading="form.processing" 
              class="btn-blue ml-3" 
              type="submit"
            >
              Create Group
            </loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import CheckboxInput from '@/Shared/CheckboxInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    TextInput,
    CheckboxInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    systems: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        description: '',
        system_id: null,
        is_active: true,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/accessory-groups')
    },
  },
}
</script>